import { render, staticRenderFns } from "./MinDataTable.vue?vue&type=template&id=74dfa91a&scoped=true"
import script from "./MinDataTable.vue?vue&type=script&lang=js"
export * from "./MinDataTable.vue?vue&type=script&lang=js"
import style0 from "./MinDataTable.vue?vue&type=style&index=0&id=74dfa91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfa91a",
  null
  
)

export default component.exports